import { defineMessages } from "@formatjs/intl";

const PREFIX = "lms.guide03.introduction-slide";
export const messages = defineMessages({
  title: {
    id: `${PREFIX}.title`,
  },
  description: {
    id: `${PREFIX}.description`,
  },
  option1: {
    id: `${PREFIX}.option1`,
  },
  option2: {
    id: `${PREFIX}.option2`,
  },
  option3: {
    id: `${PREFIX}.option3`,
  },
  option4: {
    id: `${PREFIX}.option4`,
  },
  option5: {
    id: `${PREFIX}.option5`,
  },
  slide1Option1: {
    id: `${PREFIX}.slide1.option1`,
  },
  slide1Option2: {
    id: `${PREFIX}.slide1.option2`,
  },
  slide1Option3: {
    id: `${PREFIX}.slide1.option3`,
  },
  slide2Title: {
    id: `${PREFIX}.slide2.title`,
  },
  slide2Title1: {
    id: `${PREFIX}.slide2.title1`,
  },
  slide2Title2: {
    id: `${PREFIX}.slide2.title2`,
  },
  slide2Title3: {
    id: `${PREFIX}.slide2.title3`,
  },
  slide2Description1: {
    id: `${PREFIX}.slide2.description1`,
  },
  slide2Description2: {
    id: `${PREFIX}.slide2.description2`,
  },
  slide2Description3: {
    id: `${PREFIX}.slide2.description3`,
  },
  slide3Title: {
    id: `${PREFIX}.slide3.title`,
  },
  slide3Title1: {
    id: `${PREFIX}.slide3.title1`,
  },
  slide3Title2: {
    id: `${PREFIX}.slide3.title2`,
  },
  slide3Title3: {
    id: `${PREFIX}.slide3.title3`,
  },
  slide3Title4: {
    id: `${PREFIX}.slide3.title4`,
  },
  slide3Description1: {
    id: `${PREFIX}.slide3.description1`,
  },
  slide3Description2: {
    id: `${PREFIX}.slide3.description2`,
  },
  slide3Description3: {
    id: `${PREFIX}.slide3.description3`,
  },
  slide3Description4: {
    id: `${PREFIX}.slide3.description4`,
  },
  slide4Title: {
    id: `${PREFIX}.slide4.title`,
  },
  slide4Title1: {
    id: `${PREFIX}.slide4.title1`,
  },
  slide4Title2: {
    id: `${PREFIX}.slide4.title2`,
  },
  slide4Title3: {
    id: `${PREFIX}.slide4.title3`,
  },
  slide4Description1: {
    id: `${PREFIX}.slide4.description1`,
  },
  slide4Description2: {
    id: `${PREFIX}.slide4.description2`,
  },
  slide4Description3: {
    id: `${PREFIX}.slide4.description3`,
  },
  slide4Button: {
    id: `${PREFIX}.slide4.button`,
  },
  slide5Title: {
    id: `${PREFIX}.slide5.title`,
  },
  slide5Subtitle: {
    id: `${PREFIX}.slide5.subtitle`,
  },
  slide5Title1: {
    id: `${PREFIX}.slide5.title1`,
  },
  slide5Title2: {
    id: `${PREFIX}.slide5.title2`,
  },
  slide5Description1: {
    id: `${PREFIX}.slide5.description1`,
  },
  slide5Description2: {
    id: `${PREFIX}.slide5.description2`,
  },
  slide5Description3: {
    id: `${PREFIX}.slide5.description3`,
  },
  slide5Description4: {
    id: `${PREFIX}.slide5.description2`,
  },
  slide5Description5: {
    id: `${PREFIX}.slide5.description5`,
  },
  slide5Button1: {
    id: `${PREFIX}.slide5.button1`,
  },
  slide5Button2: {
    id: `${PREFIX}.slide5.button2`,
  },
  slide5Modal1Title: {
    id: `${PREFIX}.slide5.modal1.title`,
  },
  slide5Modal1Description: {
    id: `${PREFIX}.slide5.modal1.description`,
  },
  slide5Modal2Title: {
    id: `${PREFIX}.slide5.modal2.title`,
  },
  slide5Modal2Description: {
    id: `${PREFIX}.slide5.modal2.description`,
  },
});
